import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-material-charge-list',
  templateUrl: './material-charge-list.component.html',
  styleUrls: ['./material-charge-list.component.css']
})
export class MaterialChargeListComponent implements OnInit {

  materialChargeData: any = []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  singleMaterialChargeData: any= []

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getAllMaterialCharge();
  }

  getProductCompositionById(id:any){
    this.generic_service.getProductCompositionById(id).subscribe(
      (res:any)=>{
        console.log(res)
        this.singleMaterialChargeData = []
        this.singleMaterialChargeData.push(res.response)
        console.log(this.singleMaterialChargeData)
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllMaterialCharge();
  }

  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllMaterialCharge();
  }

  getAllMaterialCharge(){
    this.generic_service.getAllMaterialCharge().subscribe(
      (response:any)=>{
        console.log(response);
        this.materialChargeData = response.response
      }
    )
  }


}

